<mat-sidenav-container
  mode="slide"
  opened="false"
  class="side-nav-container"
  [attr.inert]="commAuthService.sessionTimedOut() ? '' : null"
  [attr.aria-hidden]="commAuthService.sessionTimedOut() ? 'true' : null">
  <header>
    <mat-toolbar>
      @if (authService.isAuthenticated) {
        <button class="margin-right" matIconButton (click)="sidenav.toggle()">
          <mat-icon>menu</mat-icon>
        </button>
      }
      <h1>
        {{ title }}
      </h1>
      <span class="spacer"></span>
      <!--<button mat-icon-button [mdMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="mdMenu">-->
      @if (!authService.isAuthenticated) {
        <button class="login-logout-btn" mat-button (click)="login()">
          Log In
        </button>
      }
      @else {
        <button class="login-logout-btn" mat-button (click)="logout()">
          Log Out
        </button>
      }
      <!--</mat-menu>-->
    </mat-toolbar>
  </header>
  <mat-sidenav #sidenav role="navigation">
    <mat-card class="user-header">
      <mat-card-header class="flex-row-start-center">
        <div mat-card-avatar class="card-avatar">
          <mat-icon>face</mat-icon>
        </div>
        <mat-card-title>{{ user?.FullName ?? '' }}</mat-card-title>
      </mat-card-header>
    </mat-card>
    <mat-list>
      @if (authService.isAuthenticated) {
        <mat-list-item>
          <button
            routerLink="/correspondences"
            (click)="sidenav.close()"
            mat-button
            aria-label="Correspondences">
            <mat-icon>folder special</mat-icon>
            Correspondences
          </button>
        </mat-list-item>
      }
      @if (authService.isAuthenticated) {
        <mat-divider></mat-divider>
      }
      <mat-list-item>
        <button
          routerLink="/correspondence/add"
          (click)="sidenav.close()"
          mat-button
          aria-label="Add correspondence">
          <mat-icon>add</mat-icon>
          Add Correspondence
        </button>
      </mat-list-item>
      @if (
        authService.isAuthenticated &&
        authService.hasAnyRole('Admin', 'Shepherd', 'Reviewer')
      ) {
        <mat-list-item>
          <button
            [routerLink]="['correspondences', 'awaiting-review']"
            (click)="sidenav.close()"
            mat-button
            aria-label="Correspondence awaiting review">
            <mat-icon>drafts</mat-icon>
            <!--          @if (counts) {-->
            <!--            <span>-->
            <!--              {{ counts[0]?.Count }}-->
            <!--            </span>-->
            <!--          }-->
            Awaiting Review
          </button>
        </mat-list-item>
      }
      @if (filterNames?.length && authService.isAuthenticated) {
        <mat-divider></mat-divider>
      }
      @for (filterName of filterNames; track filterName; let i = $index) {
        @if (authService.isAuthenticated) {
          <mat-list-item>
            <button
              [routerLink]="['correspondences', filterName]"
              (click)="sidenav.close()"
              mat-button
              aria-label="Custom-Filtered Correspondence">
              <mat-icon>drafts</mat-icon>
              <!--            @if (counts) {-->
              <!--              <span>-->
              <!--                {{ counts[i + 1]?.Count }}-->
              <!--              </span>-->
              <!--            }-->
              Filter: {{ filterName }}
            </button>
            <span
              mat-button
              style="cursor: pointer"
              title="Remove filter"
              aria-label="Remove filter"
              (click)="removeFilter(filterName)"
              >X</span
            >
          </mat-list-item>
        }
      }
      @if (authService.isAuthenticated) {
        <mat-divider></mat-divider>
      }
      <mat-list-item secured>
        <button
          routerLink="/users"
          (click)="sidenav.close()"
          mat-button
          aria-label="User Management">
          <mat-icon>face</mat-icon>
          User Management
        </button>
      </mat-list-item>
      @if (authService.isAuthenticated) {
        <mat-list-item>
          <button
            routerLink="/settings"
            (click)="sidenav.close()"
            mat-button
            aria-label="Settings">
            <mat-icon>settings</mat-icon>
            Settings
          </button>
        </mat-list-item>
      }
      <mat-list-item>
        <button
          routerLink="/help"
          (click)="sidenav.close()"
          mat-button
          aria-label="Help">
          <mat-icon>help</mat-icon>
          Help
        </button>
      </mat-list-item>
      @if (authService.isAuthenticated) {
        <mat-divider></mat-divider>
        <mat-list-item>
          <button
            (click)="sidenav.close(); logout()"
            mat-button
            aria-label="Logout">
            <mat-icon>logout</mat-icon>
            Logout
          </button>
        </mat-list-item>
      }
    </mat-list>
  </mat-sidenav>
  <!--<main role="main" id="wrapper"
infinite-scroll
[infiniteScrollDistance]="2"
[infiniteScrollThrottle]="300"
[scrollWindow]='false'
infiniteScrollContainer='.mat-sidenav-content'
(scrolled)="onScroll($event)">-->
  <main role="main" id="wrapper">
    <!-- login -->
    <!--<div class="container">
  <section class="info-box" *ngIf="!editMode">
    <h1 class="info-box-heading">Login</h1>
    <div class="info-box-wrapper">
      <div class="info-box-body">
        <div class="section-container col-mat-12">
          <p>Login using your Hawk identification</p>
        </div>
      </div>
      <div class="info-box-btn" layout="row" layout-align="end">
        <button mat-raised-button (click)='login()'>Login</button>
      </div>
    </div>
  </section>
</div>-->
    <router-outlet></router-outlet>
  </main>
</mat-sidenav-container>

@if (commAuthService.sessionTimedOut()) {
  <div
    class="session-timeout-overlay"
    role="dialog"
    aria-modal="true"
    aria-labelledby="session-timeout-title"
    aria-describedby="session-timeout-message">
    <section class="session-timeout-dialog">
      <mat-icon aria-hidden="true">schedule</mat-icon>
      <h2 id="session-timeout-title">Session timed out</h2>
      <p id="session-timeout-message">
        Your session ended due to inactivity. Sign in again to continue.
      </p>
      <button
        mat-flat-button
        autofocus
        (click)="commAuthService.resumeSession()">
        Sign in again
      </button>
    </section>
  </div>
}
